module.exports = __webpack_public_path__ + "img/monitoring.34bab018.png";